export const PROGRESS_BAR_SET_LENGTH = 'PROGRESS_BAR:SET_LENGTH';
export const PROGRESS_BAR_RESET = 'PROGRESS_BAR:RESET';
